// extracted by mini-css-extract-plugin
module.exports = {"mediaListItem":"MediaList_mediaListItem__4KY_8","link":"MediaList_link__SSO7F","externalIcon":"MediaList_externalIcon__cfR_o","mediaIcon":"MediaList_mediaIcon__UV58G"};